import React, { useState } from 'react'
import Button, { ButtonProps as MuiButtonProps } from '@mui/material/Button'
import { CircularProgress } from '@mui/material'
import styled from 'styled-components'

type ButtonProps = MuiButtonProps & {
    children: React.ReactNode
    loading?: boolean
    onClick: (e: React.MouseEvent<HTMLElement>) => Promise<void> | void
    disabled?: boolean
}

const StyledCircularProgress = styled(CircularProgress)`
    margin-right: 10px;
`

export default function AsyncButton({
    onClick: onClickProp,
    loading: isLoadingProp,
    disabled: disabledProp,
    children,
    ...props
}: ButtonProps) {
    const [internalIsLoading, setInternalIsLoading] = useState(false)

    const onClick = async (e: React.MouseEvent<HTMLElement>) => {
        setInternalIsLoading(true)

        try {
            await Promise.resolve(onClickProp(e))
        } catch (error) {
            console.log(error)
        }
        setInternalIsLoading(false)
    }
    const isLoading = internalIsLoading || isLoadingProp
    const isDisabled = disabledProp || isLoading

    return (
        <Button {...props} disabled={isDisabled} onClick={onClick}>
            {isLoading && <StyledCircularProgress size={22} />}
            {children}
        </Button>
    )
}
